import script from "./NewPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPayment.vue?vue&type=script&setup=true&lang=js"

import "./NewPayment.vue?vue&type=style&index=0&id=6bd6cdde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd6cdde"]])

export default __exports__